import { render, staticRenderFns } from "./base-paging.vue?vue&type=template&id=2ffd32e2"
import script from "./base-paging.vue?vue&type=script&lang=js"
export * from "./base-paging.vue?vue&type=script&lang=js"
import style0 from "./base-paging.vue?vue&type=style&index=0&id=2ffd32e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports